import * as types from "../actions/types";

interface Cart {
  products: any[];
}

// Load initial state from localStorage if available
const loadState = (): Cart => {
  try {
    const serializedState = localStorage.getItem("cart");
    if (serializedState === null) {
      return { products: [] };
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Error loading cart from localStorage:", err);
    return { products: [] };
  }
};

// Save state to localStorage
const saveState = (state: Cart) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("cart", serializedState);
  } catch (err) {
    console.error("Error saving cart to localStorage:", err);
  }
};

const initialState: Cart = loadState();

export default function cartReducer(state = initialState, action: any) {
  let newState;

  switch (action.type) {
    case types.ADD_ITEM_IN_CART: {
      const index = state.products.findIndex(
        (d) => d.id === action.value.content.id
      );
      if (index > -1) {
        newState = {
          ...state,
          products: state.products.map((product, idx) =>
            idx === index
              ? {
                  ...product,
                  quantity: product.quantity + action.value.quantity
                }
              : product
          )
        };
      } else {
        newState = {
          ...state,
          products: [
            ...state.products,
            { ...action.value.content, quantity: action.value.quantity }
          ]
        };
      }
      saveState(newState);
      return newState;
    }
    case types.ADD_DIRECT_ITEM_IN_CART: {
      const index = state.products.findIndex(
        (product) => product.id === action.value.id
      );

      if (index > -1) {
        newState = {
          ...state,
          products: state.products.map((product, i) =>
            i === index
              ? { ...product, quantity: product.quantity + 1 }
              : product
          )
        };
      } else {
        newState = {
          ...state,
          products: [...state.products, action.value]
        };
      }
      saveState(newState);
      return newState;
    }

    case types.REMOVE_ITEM_IN_CART:
      newState = {
        ...state,
        products: state.products.filter((d) => action.value !== d.id)
      };
      saveState(newState);
      return newState;

    case types.CLEAR_CART:
      newState = {
        ...state,
        products: []
      };
      saveState(newState);
      return newState;

    case types.INCREMENT_ITEM:
      newState = {
        ...state,
        products: state.products.map((product) =>
          action.value.id === product.id
            ? { ...product, quantity: action.value.quantity }
            : product
        )
      };
      saveState(newState);
      return newState;

    case types.DECREMENT_ITEM:
      newState = {
        ...state,
        products: state.products.map((product) =>
          action.value.id === product.id
            ? { ...product, quantity: action.value.quantity }
            : product
        )
      };
      saveState(newState);
      return newState;

    default:
      return state;
  }
}
